import { myAxios } from "./axios";

export function getPools(payload, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      ...(payload || {}),
    },
  };
  return myAxios.get("/pools", config);
}

export function addPool(data) {
  return myAxios.post("/pools/create", data);
}

export function editPool(id, data) {
  return myAxios.put("/pools/" + id + "/update", data);
}

export function getPool(id) {
  return myAxios.get("/pools/" + id);
}

export function deletePool(id) {
  return myAxios.delete("/pools/" + id + "/delete");
}
